import gql from 'graphql-tag'
import { TypedDocumentNode } from '@apollo/client'
import { TowingRecordFromOrderOutputResponse } from './TowingRecordFromOrderMutation'

interface TowingOrderStatusResult {
  __typename: string
  towingOrder?: { id: number; status: string; visibility?: string }
}

export interface AcceptAssignResponse { acceptAndAssignTowingOrder: TowingOrderStatusResult }
export interface AcceptResponse { acceptTowingOrder: TowingOrderStatusResult }
export interface ApproveAssignmentResponse { approveTowingOrderAssignment: TowingOrderStatusResult }
export interface CancelResponse { cancelTowingOrder: TowingOrderStatusResult }
export interface RejectResponse { rejectTowingOrderAssignment: TowingOrderStatusResult }
export interface AcceptSosResponse { acceptSosServiceOrder: TowingOrderStatusResult }

export interface TowingOrderIdVariables { id: number }
export interface CancelTowingOrderVariables { input: { id: number; reason?: string } }
export interface RejectTowingOrderVariables { input: { id: number; reason?: string } }
export interface TowingRecordFromOrderVariables { towingOrderId: number }
export interface AcceptSosVariables { input: { id: number; acceptedByDriverDetails: { driverName: string } } }

export const ACCEPT_AND_ASSIGN_TOWING_ORDER: TypedDocumentNode<AcceptAssignResponse, TowingOrderIdVariables> = gql`
  mutation AcceptAndAssignTowingOrder($id: Int!) {
    acceptAndAssignTowingOrder(input: { id: $id }) {
      __typename
      ... on AcceptAndAssignTowingOrderSuccess {
        towingOrder {
          id
          status
        }
      }
      ... on StatusChangeForbiddenError {
        error {
          message
        }
      }
    }
  }
`

export const ACCEPT_TOWING_ORDER: TypedDocumentNode<AcceptResponse, TowingOrderIdVariables> = gql`
  mutation AcceptTowingOrder($id: Int!) {
    acceptTowingOrder(input: { id: $id }) {
      __typename
      ... on AcceptTowingOrderSuccess {
        towingOrder {
          id
          status
        }
      }
      ... on StatusChangeForbiddenError {
        error {
          message
        }
      }
    }
  }
`

export const APPROVE_TOWING_ORDER_ASSIGNMENT: TypedDocumentNode<ApproveAssignmentResponse, TowingOrderIdVariables> = gql`
  mutation ApproveTowingOrderAssignment($id: Int!) {
    approveTowingOrderAssignment(input: { id: $id }) {
      __typename
      ... on ApproveTowingOrderAssignmentSuccess {
        towingOrder {
          id
          status
        }
      }
    }
  }
`

export const CANCEL_TOWING_ORDER: TypedDocumentNode<CancelResponse, CancelTowingOrderVariables> = gql`
  mutation CancelTowingOrder($input: CancelTowingOrderInput!) {
    cancelTowingOrder(input: $input) {
      __typename
      ... on CancelTowingOrderSuccess {
        towingOrder {
          id
          status
          visibility
        }
      }
    }
  }
`

export const REJECT_TOWING_ORDER: TypedDocumentNode<RejectResponse, RejectTowingOrderVariables> = gql`
  mutation RejectTowingOrderAssignment($input: RejectTowingOrderAssignmentInput!) {
    rejectTowingOrderAssignment(input: $input) {
      __typename
      ... on RejectTowingOrderAssignmentSuccess {
        towingOrder {
          id
          status
          visibility
        }
      }
    }
  }
`

export const CREATE_TOWING_RECORD_FROM_ORDER: TypedDocumentNode<TowingRecordFromOrderOutputResponse, TowingRecordFromOrderVariables> = gql`
  mutation TowingRecordFromOrder($towingOrderId: Int!) {
    towingRecordFromOrder(input: { towingOrderId: $towingOrderId }) {
      __typename
      ... on TowingRecordFromOrderSuccess {
        towingRecord {
          id
          jobStatus
          type
        }
      }
      ... on StatusChangeForbiddenError {
        error {
          message
        }
      }
    }
  }
`

// SOS specific queries

export const ACCEPT_SOS_SERVICE_ORDER: TypedDocumentNode<AcceptSosResponse, AcceptSosVariables> = gql`
  mutation AcceptSosServiceOrder($input: AcceptSosServiceOrderInput!) {
    acceptSosServiceOrder(input: $input) {
      __typename
      ... on ServiceOrderAcceptedSuccess {
        towingOrder {
          id
          status
        }
      }
    }
  }
`
